if(screen.width <= 767){
$("a#order-ahead").on('click',function() {
  window.scrollTo({
      top: 400,
      left: 0,
      behavior: 'smooth'
  });
});
$("a#order-in-person").on('click',function() {
  window.scrollTo({
        top: 400,
        left: 0,
        behavior: 'smooth'
    });
}); 
}
else{
  $("a#order-ahead").on('click',function() {
     window.scrollTo({
        top: 600,
        left: 0,
        behavior: 'smooth'
      });
    });
  $("a#order-in-person").on('click',function() {
      window.scrollTo({
        top: 600,
        left: 0,
        behavior: 'smooth'
      });
  }); 
}
